<template>
    <div v-if="modal.show" class="base-modal-container">
        <div @click="() => (show = false)" class="base-modal-overlay"></div>
        <div
            ref="modalRef"
            :style="styles.modalWrapper ? styles.modalWrapper : {}"
            class="base-modal-wrapper"
        >
            <slot></slot>
        </div>
    </div>
</template>
<script>
    import { ref } from 'vue'
    import { useModal, useModalController } from '@/composables/ui/useModal.js'
    export default {
        name: 'BaseModal',
        props: {
            mk: {
                required: true,
                type: String
            },
            show: {
                required: true,
                type: Boolean
            },
            timer: {
                requried: false,
                type: Number,
                default: 0
            },
            scroll: {
                required: false,
                type: Boolean,
                default: true
            },
            styles: {
                required: false,
                type: Object,
                default: () => ({})
            }
        },
        emits: ['update:show', 'open', 'close'],
        setup(props) {
            const modalRef = ref(null)
            const { modal, modals } = useModal({
                key: props.mk,
                base: true,
                timer: props.timer
            })
            const { openModal, closeModal } = useModalController(
                props.mk,
                modalRef,
                props.scroll
            )

            return { modalRef, modal, openModal, closeModal, modals }
        },
        watch: {
            show: {
                handler: function (show) {
                    if (show) {
                        this.openModal()
                        this.$emit('update:show', true)
                        this.$emit('open')
                    } else {
                        this.closeModal()
                        this.$emit('update:show', false)
                        this.$emit('close')
                    }
                },
                immediate: true
            }
        }
    }
</script>
<style lang="scss" scoped>
    $mobileMax: 600px;

    @media screen and (max-width: $mobileMax) {
        .base-modal-container {
            .base-modal-overlay {
                opacity: 1 !important;
                background: black !important;
            }
            .base-modal-wrapper {
                background: black;
            }
        }
    }
    @keyframes fade {
        0% {
            opacity: 0;
        }
        100% {
            opacity: 1;
        }
    }
    .base-modal-container {
        max-width: 3000px;
        min-width: 320px;
        width: 100%;
        display: flex;
        flex-direction: row;
        justify-content: center;

        .base-modal-overlay {
            background: #121212;
            opacity: 0.8;
            position: fixed;
            bottom: 0;
            top: 0;
            left: 0;
            right: 0;
            width: 100vw;
            height: 120vh;
            z-index: 119;
        }
        .base-modal-wrapper::-webkit-scrollbar {
            display: none;
        }
        .base-modal-wrapper {
            width: 100%;
            max-height: 100%;
            overflow-y: auto;
            display: flex;
            flex-direction: row;
            justify-content: center;
            position: absolute;
            top: 42%;
            z-index: 1020;
            animation: fade 1s ease forwards;
            -ms-overflow-style: none;
            scrollbar-width: none;
        }
    }
</style>
